import React from 'react'

import {
  Button, Icon, GestureSwipeHorizontal, FullScreen, Close, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, bool } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'


function Header({
  onCloseGallery = NOOP,
  activeIndex,
  totalCount,
  showSwipeButton,
  fullScreenGallery,
  triggerFullScreenGallery,
}) {
  return (
    <div className="cgt-model-gallery-new__header">
      <div className="cgt-model-gallery-new__header-left">
        {!fullScreenGallery && totalCount > 0 && (
          <Button
            actionType="button"
            icon={<Icon svgComponent={FullScreen} color="light" />}
            type="ghost"
            variant="only-icon"
            onClick={triggerFullScreenGallery}
            color="white-100"
            customClass="cgt-model-gallery-new__fullscreen-button"
          />
        )}
        {totalCount > 0 && (
          <p className="cgt-model-gallery-new__images-count cgt-legacy-heading-h6 cgt-legacy-color-white-100">
            {`${activeIndex + 1}/${totalCount}`}
          </p>
        )}
      </div>
      {totalCount > 1 && (
        <Button
          actionType="button"
          icon={<Icon svgComponent={GestureSwipeHorizontal} color="light" />}
          type="ghost"
          variant="with-icon"
          color="white-100"
          customClass={classnames(
            'cgt-model-gallery-new__swipe-button',
            !showSwipeButton && 'cgt-model-gallery-new__swipe-button--hidden',
          )}
        >
          Swipe
        </Button>
      )}
      <Button
        actionType="button"
        icon={<Close width="20" height="20" />}
        type="ghost"
        variant="only-icon"
        onClick={fullScreenGallery ? triggerFullScreenGallery : onCloseGallery}
        color="white-100"
        customClass="cgt-model-gallery-new__button"
      />
    </div>
  )
}

Header.propTypes = {
  activeIndex: number.isRequired,
  totalCount: number.isRequired,
  onCloseGallery: func,
  showSwipeButton: bool.isRequired,
  fullScreenGallery: bool.isRequired,
  triggerFullScreenGallery: func.isRequired,
}

export default Header
